export const scorecardDataKeys = {
  all: ['scorecards'] as const,
  snapshots: () => [...scorecardDataKeys.all, 'snapshots'] as const,
  metrics: (snapshotDt?: string | null) =>
    [...scorecardDataKeys.all, 'metrics', snapshotDt ?? 'current'] as const,
};
